import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "time-selector" }
const _hoisted_2 = { class: "time-selector__content" }
const _hoisted_3 = { class: "time-selector__value is-flex is-align-items-center" }
const _hoisted_4 = { class: "time-selector__icon is-size-4" }

import EditableComponent from '@/shared/components/EditableComponent.vue';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeSelector',
  props: {
  modelValue: {
    type: Date,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const selectedDate = useVModel(props, 'modelValue', emit);

function handleDateChange(date: Date) {
  selectedDate.value = date;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_n_tooltip, {
            text: "Set the date and time to use in the preview tool",
            position: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: ['far', 'clock'] })
            ]),
            _: 1
          })
        ]),
        _createVNode(EditableComponent, {
          type: "datetime-local",
          modelValue: _unref(selectedDate),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedDate) ? (selectedDate).value = $event : null)),
          onInput: handleDateChange,
          options: [],
          fieldName: "Current Time",
          displayRelativeDate: false,
          displayIcon: true
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})